import { render, staticRenderFns } from "./HangmanEdit.vue?vue&type=template&id=5c65a5a4"
import script from "./HangmanEdit.vue?vue&type=script&lang=js"
export * from "./HangmanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports